import script from "./Survey360ResultsView.vue?vue&type=script&setup=true&lang=js"
export * from "./Survey360ResultsView.vue?vue&type=script&setup=true&lang=js"

import "./Survey360ResultsView.vue?vue&type=style&index=0&id=60620c22&lang=scss"

const __exports__ = script;

export default __exports__